<template>
  <div>
		<div id="narrowYourResults" class="course-search-result-section">
			<div class="colummn-section">
				<div class="facets">
          <div class="main_head">
						<span class="icon-filter"></span>
						<span class="head_txt">Narrow Your Results</span>
					</div>

					<div class="facet_block_container">
						<div class="facet_block">
							<div class="folder-section">
								<div class="facet_row_container">
									<div v-if="showCourseSectionTags" class="course-tag-container">
									  <!-- <span> spring 2018 </span> -->
									  <template v-if="showCourseSectionTags" v-for="facet in formattedFacets.facetedCourseTags">
										<div class="field-row"><input type="checkbox" @input="facetSelected(facet, 'facetedCourseTags')">{{facet.term}} [{{facet.count}}]</input></div>
									  </template>
									  <!-- <input type="checkbox" v-model="" -->
									</div>
								</div>
							</div>
						</div>

						<div class="facet_block">
							<div class="head">
								<div class="checkbox">
									<input type="checkbox" :checked="showCourseFacets" @input="showCourseFacets = !showCourseFacets"></input>
								</div>
								<div class="head_txt">Catalog Course</div>
								<!-- <input type="checkbox" @input="showCourseSectionTags = !showCourseSectionTags"> -->
							</div>
							<div class="folder-section">
								<div class="facet_row_container">
                  <div v-if="showCourseFacets" class="remaning-section">
                    <div v-if="showCourseFacets && formattedFacets.catalogCourseDepartment.length > 0">
                      <div class="subheading-row">Department</div>
                      <template v-if="showCourseFacets" v-for="facet in formattedFacets.catalogCourseDepartment">
                        <div class="field-row"><input type="checkbox" :checked="facet.isSelected" @input="facetSelected(facet, 'catalogCourseDepartment')">{{facet.term}} [{{facet.count}}]</input></div>
                      </template>
                    </div>
                    <div v-if="showCourseFacets && formattedFacets.catalogCourseSubject.length > 0">
                      <div class="subheading-row">Subject</div>
                      <template v-if="showCourseFacets" v-for="facet in formattedFacets.catalogCourseSubject" >
                        <div class="field-row"><input type="checkbox" :checked="facet.isSelected" @input="facetSelected(facet, 'catalogCourseSubject')">{{facet.term}} [{{facet.count}}]</input></div>
                      </template>
                    </div>
                    <div v-if="showCourseFacets && formattedFacets.catalogCourseDivision.length > 0">
                      <div class="subheading-row">Division</div>
                      <template v-if="showCourseFacets" v-for="facet in formattedFacets.catalogCourseDivision" >
                        <div class="field-row"><input type="checkbox" :checked="facet.isSelected" @input="facetSelected(facet, 'catalogCourseDivision')">{{facet.term}} [{{facet.count}}]</input></div>
                      </template>
                    </div>
                    <div v-if="showCourseFacets && formattedFacets.catalogCourseGradeLevel.length > 0">
                      <div class="subheading-row">Level</div>
                      <template v-if="showCourseFacets" v-for="facet in formattedFacets.catalogCourseGradeLevel" >
                        <div class="field-row"><input type="checkbox" :checked="facet.isSelected" @input="facetSelected(facet, 'catalogCourseGradeLevel')">{{facet.term}} [{{facet.count}}]</input></div>
                      </template>
                    </div>
									</div>
								</div>
							</div>
						</div>

					</div>
				</div>

				<div class="mid-panel datatable catalog-search-section">
					<div class="list-header">
						<div class="float-left left-container">
							<div id="resultsHeader">
							  <b-dropdown id="ddown1" text="Dropdown Button" class="m-md-2">
								<template slot="button-content" v-if="isListView">
								  <span class="fas fa-bars"></span>
								</template>
								<template slot="button-content" v-else>
								  <span class="fas fa-bars"></span>
								</template>
								<b-dropdown-header><span class="view-title">change view to</span> 
								    <button class="btn_close" aria-label="close" @click="closeChangeView">
                                       <span class="ic-close"></span>
                                     </button>
								</b-dropdown-header>
								<b-dropdown-item @click="listViewClicked">List View</b-dropdown-item>
								<b-dropdown-item @click="gridViewClicked">Grid View</b-dropdown-item>
							  </b-dropdown>
							</div>
						</div>
						<div class="right-container">
							<div class="number-of-item" tabindex="0">
								<b-dropdown id="ddown-buttons" :text="''+size" :options="sizeOptions" aria-label="number of item">
									  <template v-for="(option, index) in sizeOptions">
										  <b-dropdown-divider v-if="index > 0"></b-dropdown-divider>
										  <b-dropdown-item @click="changeSize(option)">{{option}}</b-dropdown-item>
									  </template>
								</b-dropdown>
							</div>
							<div class="pagination btn_container pagination_sty3">
                <button type="button" class="btn btn_trans" @click="firstPage" :title="$t('firstPageLabel')" :aria-label="$t('firstPageLabel')"><span class="ic2_arr_pre3" aria-hidden="true"></span></button>
								<button type="button" class="btn btn_trans" @click="prevPage" :title="$t('previousPage')" :aria-label="$t('previousPage')"><span class="ic2_arr_pre3" aria-hidden="true"></span></button>
								<span class="current-page">{{pageNumber}}</span>
								<button type="button" class="btn btn_trans" @click="nextPage" :title="$t('nextPage')" :aria-label="$t('nextPage')"><span class="ic2_arr_next3" aria-hidden="true"></span></button>
                <button type="button" class="btn btn_trans" @click="lastPage" :title="$t('lastPageLabel')" :aria-label="$t('lastPageLabel')"><span class="ic2_arr_next3" aria-hidden="true"></span></button>
							</div>

						</div>
					</div>

          <div v-if="loading">Loading Results...</div>
          <span v-else-if='!loading && formattedResults.length === 0' class="course-search-no-result">No results found!</span>

					<div id="listViewResults" class="list-view-section" v-if='isListView'>
					  <template v-if="formattedResults.length > 0" v-for="course in formattedResults">
						<div class="item-row">
							<div class="header-row">
								<div class="add-to-stream-column">
									<div class="course-title">
										<span class="icon ico-catalog"></span>
										<span class="title-name" @click.stop="navigateToCatalog(course)">{{course.title}}</span>
									</div>
								</div>
							</div>
						    <div class="description-section">
								<div class="description-column">
								  <div class="course-desc">
									<span class="fas fa-bars icon"></span>
									<span class="desc-col">{{course.description}}</span>
								  </div>
								  <div class="course-content">
									<ul>
										<li>Section: {{course.section}}</li>
										<li>CRN: {{course.crn}}</li>
										<li>Meeting Days: {{course.days}}</li>
										<li>Meeting Times: {{course.times}}</li>
										<li>Enrollment: {{course.enrollment}}</li>
										<li>Credit: {{course.creditHour}}</li>
										<li>Room Information: {{course.roomInformation}}</li>
										<li>{{course.specialInstructions}}</li>
									</ul>
								  </div>
								</div>
								<div class="thumbnail-section">
									<div class="thumbnail_default ico-catalog"></div>
								</div>

							</div>
						</div>
					  </template>
					</div>

					<div id="gridViewResults" class="grid-view-section" v-else>
					  <template v-if="formattedResults.length > 0" v-for="course in formattedResults">
						<div class="grid-box">
							<div class="entity-container" @click.stop="navigateToCatalog(course)">
							  <div class="thumbnail">
								<span class="ico-catalog icon"></span>
							  </div>
							  <div :id="course.uuid" class="title-row">
								<span class="title">{{course.title}}</span>
							  </div>
							</div>
						  <div id="grid-view-popover" class="grid-view-popover"></div>
							  <b-popover :target="course.uuid"
										 :title="course.title"
										 triggers="hover focus"
										 container="grid-view-popover">
								<span class="course-desc">{{course.description}}</span>

								<span class="content-column">Section: {{course.section}}</span>
								<span class="content-column">CRN: {{course.crn}}</span>
								<span class="content-column">Meeting Days: {{course.days}}</span>
								<span class="content-column">Meeting Times: {{course.times}}</span>
								<span class="content-column">Enrollment: {{course.enrollment}}</span>
								<span class="content-column">Credit: {{course.creditHour}}</span>
								<span class="content-column">Room Information: {{course.roomInformation}}</span>
								<span class="content-column">{{course.specialInstructions}}</span>
							  </b-popover>
						</div>
					  </template>
					</div>

				</div>
			</div>
		</div>
	</div>
</template>

<script>
  import '../../../assets/module/css/discover/courseSearch.min.css'
  import { mapActions, mapState } from 'vuex'

  export default {
    name: 'catalog-search-results',
    components: {
    },
    data: () => {
      return {
        loading: false,
        selectAllFolders: true,
        folders: [],
        allFolders: [],
        foldersSelected: [],
        privateLibraryList: [],
        publicLibraryList: [],
        userId: '',
        userRole: '',
        assetType: [],
        assetTypeSelected: [],
        courseType: [],
        courseTypeSelected: [],
        indexList: '',
        filter: {},
        libraryList: '',
        indexesSelected: [],
        allIndexes: ['catalog'],
        source: [
          'uuid',
          'title',
          'description',
          'creationTime',
          'lastUpdatedTime',
          'type',
          'ancestor',
          'owningLibraryId',
          'ownerName',
          'ownerId',
          'originUuid',
          'thumbnailURIList',
          'appliedTagMap',
          'facetedCourseTags',
          'maxSeats',
          'currentSeats',
          'roomInformation',
          'meetingDays',
          'meetingFromTime',
          'meetingToTime',
          'specialInstructions',
          'crn',
          'division',
          'department',
          'departmentCode',
          'subject',
          'subjectCode',
          'level',
          'maxCredit',
          'minCredit',
          'creditHour',
          'prerequisites',
          'corequisities',
          'catalogCourseId',
          'instructorNames',
          'num',
          'meetingDaysRaw',
          'meetingDaysFormatted',
          'termCode',
          'timeSlots',
          'courseFlags',
          'catalogId',
          'courseMajors',
          'courseMajorCodes',
          '_score'
        ],
        sizeOptions: [ 10, 50, 100 ],
        ignoreFolderWatch: false,
        ignoreCourseWatch: false,
        ignoreAssetWatch: false,
        destination: {},
        copyMoveDestinationFolders: [],
        searchText: '',
        isListView: true,
        showCourseSectionTags: false,
        showCourseFacets: true,
        courseFlags: [],
        coursesInStream: [],
        showDropDown: false,
        facetFieldMap: {
          facetedCourseTags: 'facetedCourseTags.tagNames',
          catalogCourseDepartment: 'department',
          catalogCourseSubject: 'subject',
          catalogCourseDivision: 'division',
          catalogCourseCredit: 'creditHour',
          catalogCourseTime: 'timeSlots',
          catalogCourseFlag: 'courseFlags',
          catalogCourseGradeLevel: 'gradeLevel'
        },
        selectedFacetNames: []
      }
    },
    mounted () {
      this.userId = localStorage.getItem('userid')
      this.loadLibraryPositionMapping()
      this.initializeSearchFilter()
      this.loadData()
    },
    methods: {
      ...mapActions([
        'populateCourses',
        'loginToGoogleCalendar',
        'executeCatalogSearch',
        'refreshCatalogSearchResults',
        'loadUserInfo',
        'loadAllLibraryForUser',
        'loadLibraryPositionMapping',
        'updateFrom',
        'updatePageNumber',
        'updateSize',
        'addToMyStream',
        'addStreamCourse',
        'setFacetSelected',
        'showCatalogSearchDropDown',
        'hideCatalogSearchDropDown'
      ]),
      closeChangeView () {
        $('.dropdown-menu, #ddown1').removeClass('show')
      },
      loadData () {
        this.setupUserLibraries()
        let shouldUpdateFacets = true
        this.executeSearch(shouldUpdateFacets)
      },
      onShown () {
        this.executeSearch()
      },
      buildFacet (field, size, order, facetName) {
        return {
          'terms': {
            'field': field,
            'size': size,
            'order': order
          },
          'facet_filter': this.getFacetFilter(facetName)
        }
      },
      executeSearch (resetFacets) {
        let buildFacet = this.buildFacet
        let getFacetFilter = this.getFacetFilter
        let facets = {
          'library': {
            'terms': {
              'field': 'owningLibraryId'
            },
            'facet_filter': getFacetFilter()
          },
          'facetedCourseTags': buildFacet('facetedCourseTags.tagNames', 100, 'term'),
          'catalogCourseDivision': buildFacet('division', 100, 'term', 'catalogCourseDivision'),
          'catalogCourseDepartment': buildFacet('department', 100, 'term', 'catalogCourseDepartment'),
          'catalogCourseSubject': buildFacet('subject', 100, 'term', 'catalogCourseSubject'),
          'catalogCourseCredit': buildFacet('creditHour', 100, 'term', 'catalogCourseCredit'),
          'catalogCourseInstructor': buildFacet('instructorNames', 100, 'term', 'catalogCourseInstructor'),
          'catalogCourseTime': buildFacet('timeSlots', 100, 'reverse_term', 'catalogCourseTime'),
          'catalogCourseFlag': buildFacet('courseFlags', 100, 'term', 'catalogCourseFlag'),
          'catalogCourseGradeLevel': buildFacet('gradeLevel', 50, 'term', 'catalogCourseGradeLevel')
        }

        this.loading = true
        let filter = this.filterForQuery()
        const params = {
          source: this.source,
          from: this.from,
          size: this.size,
          indexList: this.formattedIndexList,
          libraryList: this.formattedLibraryList,
          privateLibraryList: this.privateLibraryList,
          publicLibraryList: this.publicLibraryList,
          userId: this.userId,
          facets: facets,
          filter: filter,
          facetNames: this.allFacetNames,
          selectedFacetNames: this.selectedFacetNames
        }
        let loadSearchResults = resetFacets === true ? this.refreshCatalogSearchResults : this.executeCatalogSearch
        loadSearchResults(params).then(response => {
          this.loading = false
        })
      },
      getFacetFilter (facetName) {
        var facetFilterObj = {
          'and': [ this.originUuidCheck() ]
        }
        if (this.filter && facetName && !this.selectedFacetNames.includes(facetName)) {
          facetFilterObj['and'] = facetFilterObj['and'].concat(this.filterForQuery())
        }
        return facetFilterObj
      },
      originUuidCheck () {
        var originUuidCheck = {
          'missing': {
            'field': 'originUuid',
            'existence': true,
            'null_value': true
          }
        }
        return originUuidCheck
      },
      setupUserLibraries () {
        var userPreferences = {}
        this.loadUserInfo().then(res => {
          userPreferences = res.userPreferences
        })
        setTimeout(() => {
          this.loadAllLibraryForUser().then(libraries => {
            this.folders = []
            this.allFolders = []
            this.foldersSelected = []
            this.publicLibraryList = []
            this.privateLibraryList = []
            this.ignoreFolderWatch = true
            var learningSpaces = this.sortLibrariesIntoStandardOrder(libraries)
            if (learningSpaces && learningSpaces.length > 0) {
              var selectedLearningSpaces = userPreferences.learningSpaces
              for (var i = 0; i < learningSpaces.length; i++) {
                let learningSpace = learningSpaces[i]
                const category = learningSpace.category
                if (category === 'Institute_Public') {
                  this.folders.push({value: learningSpace.uuid, text: learningSpace.displayName + '[0]'})
                  this.ignoreFolderWatch = true
                  this.allFolders.push(learningSpace.uuid)
                  if (selectedLearningSpaces.includes(learningSpace.uuid)) {
                    this.foldersSelected.push(learningSpace.uuid)
                  }
                  if (category !== 'Institute' && category !== 'User_Private') {
                    this.publicLibraryList.push(learningSpace.uuid)
                  }
                  if (category === 'User_Private') {
                    this.privateLibraryList.push(learningSpace.uuid)
                  }
                }
                let permission = learningSpace.acelist[0].permission
                if (permission && permission.folderPermission && permission.folderPermission.allowedAsDestinationFolder) {
                  this.copyMoveDestinationFolders.push(learningSpace)
                }
              }
            }
            this.executeSearch()
          })
        }, 250)
      },
      sortLibrariesIntoStandardOrder (libraries) { // TODO remove if not needed, seems to have no effect on library order
        var sortedLibraryList = []
        for (var attr in this.libraryPositionMapping) {
          var value = this.libraryPositionMapping[attr]
          for (var i = 0; i < libraries.length; i++) {
            var library = libraries[i]
            if (this.libraryMatches(library, value)) {
              sortedLibraryList.push(library)
            }
          }
        }
        return sortedLibraryList
      },
      libraryMatches (library, value) {
        if (library.category === 'LearningSpace') {
          if (library.title === 'Shared With Me') {
            if (value === 'Shared') {
              return true
            }
          } else {
            if (value === 'Global') {
              return true
            }
          }
        }
        return library.category.indexOf(value) !== -1
      },
      listViewClicked () {
        this.isListView = true
      },
      gridViewClicked () {
        this.isListView = false
      },
      getFormattedDayAndTimeStrings (course) {
        let days = ''
        let times = ''

        if (course.meetingDaysRaw) {
          course.meetingDaysRaw.forEach(function (meetingDay) {
            days += (meetingDay.day) ? (meetingDay.day + '; ') : ''
            times += (meetingDay.meetingFromTime) ? (meetingDay.meetingFromTime + ' - ' + meetingDay.meetingToTime + '; ') : ''
          })
        }
        return {days: days, times: times}
      },
      buildTermsFilter (field, value) {
        let filter = {
          'terms': {}
        }
        filter.terms[field] = [value]
        return filter
      },
      buildFilterTermClause (arrayName, array) {
        let clause = {
          'terms': {}
        }
        clause.terms[arrayName] = array
        return clause
      },
      facetSelected (facet, facetName) {
        const fieldName = this.facetFieldMap[facetName]
        const fieldValue = facet.term
        if (this.isTermFilterSelected(facet, fieldName)) {
          // remove filter term
          this.filter[fieldName] = this.filter[fieldName].filter(v => v !== fieldValue)

          // remove facetName if list is filter clause is empty
          if (this.selectedFacetNames.includes(facetName) && this.filter[fieldName].length === 0) {
            this.selectedFacetNames = this.selectedFacetNames.filter(v => v !== facetName)
          }
          // this.setFacetSelected({facet: facet, isSelected: false, facetName: facetName})
        } else {
          this.filter[fieldName].push(fieldValue)
          if (!this.selectedFacetNames.includes(facetName)) {
            this.selectedFacetNames.push(facetName)
          }
          // this.setFacetSelected({facet: facet, isSelected: true, facetName: facetName})
        }

        this.updateFrom(0)
        this.updatePageNumber(1)
        this.executeSearch()
      },
      selectAllSemesters () {
        // TODO iterate over ever facetedCourseTags.tagNames and set an isSelected prop for v-model
      },
      changeSize (option) {
        this.updateSize(option)
        this.updateFrom(0)
        this.updatePageNumber(1)
        this.executeSearch()
      },
      prevPage () {
        if (this.pageNumber >= 1 && (this.from - this.size) >= 0) {
          this.updatePageNumber(this.pageNumber - 1)
          this.updateFrom(this.from - this.size)
          this.executeSearch()
        }
      },
      nextPage () {
        if ((this.from + this.size) < this.total) {
          this.updatePageNumber(this.pageNumber + 1)
          this.updateFrom(this.from + this.size)
          this.executeSearch()
        }
      },
      firstPage () {
        this.updatePageNumber(1)
        this.updateFrom(0)
        this.executeSearch()
      },
      lastPage () {
        if (this.total <= this.size) {
          return
        }
        let pageCounter = 1
        let fromCounter = 0
        while (fromCounter < (this.total - this.size)) {
          pageCounter += 1
          fromCounter += this.size
        }
        this.updatePageNumber(pageCounter)
        this.updateFrom(this.total - this.size)
        this.executeSearch()
      },
      joinListWithCommas (stringList) {
        let str = []

        for (var i = 0; i < stringList.length; i++) {
          if (str.length === 0) {
            str = stringList[i]
          } else {
            str = str + ',' + stringList[i]
          }
        }
        return str
      },
      closeDropDown () {
        this.hideCatalogSearchDropDown()
      },
      navigateToCatalog (catalog) {
        return this.$router.push({ name: 'catalogDetail', params: { uuid: catalog.uuid } })
      },
      isTermFilterSelected (facet, fieldName) {
        let valuesToFilter = this.filter[fieldName]
        let fieldValue = facet.term
        return valuesToFilter && valuesToFilter.includes(fieldValue)
      },
      initializeSearchFilter () {
        let filter = this.filter
        Object.values(this.facetFieldMap).forEach(fieldName => {
          filter[fieldName] = []
        })
      },
      filterForQuery () {
        let formattedFilter = []
        let filter = this.filter
        let buildTermClause = this.buildFilterTermClause
        Object.keys(filter).forEach(key => {
          let array = filter[key]
          if (array && array.length > 0) {
            formattedFilter.push(buildTermClause(key, array))
          }
        })
        return formattedFilter
      }
    },
    computed: {
      ...mapState({
        'query': state => state.advancedSearch.query,
        'results': state => state.advancedSearch.catalogResults,
        'sort': state => state.advancedSearch.sort,
        '_source': state => state.advancedSearch._source,
        'from': state => state.advancedSearch.from,
        'size': state => state.advancedSearch.size,
        'pageNumber': state => state.advancedSearch.pageNumber,
        'facets': state => state.advancedSearch.catalogFacets,
        'terms': state => state.advancedSearch.terms,
        'department': state => state.advancedSearch.department,
        'subject': state => state.advancedSearch.subject,
        'division': state => state.advancedSearch.division,
        'instructor': state => state.advancedSearch.instructor,
        'major': state => state.advancedSearch.major,
        'unit': state => state.advancedSearch.unit,
        'qr': state => state.advancedSearch.qr,
        'monday': state => state.advancedSearch.monday,
        'tuesday': state => state.advancedSearch.tuesday,
        'wednesday': state => state.advancedSearch.wednesday,
        'thursday': state => state.advancedSearch.thursday,
        'friday': state => state.advancedSearch.firstyear,
        'classTimeFrom': state => state.advancedSearch.classTimeFrom,
        'classTimeTo': state => state.advancedSearch.classTimeTo,
        'firstyear': state => state.advancedSearch.firstyear,
        'lastUpdatedTime': state => state.advancedSearch.catalogSearchTimeStamp,
        'selectedStreamUuid': state => state.advancedSearch.selectedStreamUuid,
        'semester': state => state.advancedSearch.semester,
        'total': state => state.advancedSearch.catalogTotal,
        'shouldShowDropDown': state => state.advancedSearch.showCatalogSearchDropDown,
        'semesterCourses': state => state.semester.courses,
        'streams': state => state.semester.streams,
        'libraryPositionMapping': state => state.search.libraryPositionMapping
      }),
      formattedIndexList () {
        let allIndices = this.allIndexes
        return this.joinListWithCommas(allIndices)
      },
      formattedLibraryList () {
        let allFolders = this.allFolders
        return this.joinListWithCommas(allFolders)
      },
      formattedResults () {
        let formatted = []
        let formatDayAndTime = this.getFormattedDayAndTimeStrings
        let results = this.results // TODO
        if (!results || results.length <= 0) {
          return formatted
        }
        results.forEach(function (result) {
          let dayAndTimeStrings = formatDayAndTime(result)
          result['section'] = '#' + result['num']
          result['days'] = dayAndTimeStrings['days']
          result['times'] = dayAndTimeStrings['times']
          result['enrollment'] = result['currentSeats'] + '/' + result['maxSeats']
          formatted.push(result)
        })

        return formatted
      },
      formattedFacets () {
        let formattedFacets = {}
        let facets = this.facets // TODO
        let isTermFilterSelected = this.isTermFilterSelected
        let facetFieldMap = this.facetFieldMap
        this.allFacetNames.forEach((facetName) => {
          const fieldName = facetFieldMap[facetName]
          let facetResult = (facets[facetName] && facets[facetName].terms) ? facets[facetName].terms : []
          if (facetResult) {
            facetResult.forEach((termFacet) => {
              termFacet.isSelected = isTermFilterSelected(termFacet, fieldName)
            })
          }
          formattedFacets[facetName] = facetResult
        })
        return formattedFacets
      },
      allFacetNames () {
        return Object.keys(this.facetFieldMap)
      }
    },
    watch: {
      lastUpdatedTime (newTime) {
        this.initializeSearchFilter()
        let shouldUpdateFacets = true
        this.executeSearch(shouldUpdateFacets)
      }
    }
  }
</script>

<style scoped>
.conflict {
    color: red
}

.no-conflict {
    color: green
}
</style>



// WEBPACK FOOTER //
// src/app/advancedSearch/components/CatalogSearchResults.vue